/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const SettingSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1201 8.78C14.151 8.53 14.1716 8.27 14.1716 8C14.1716 7.73 14.151 7.47 14.1099 7.22L15.8482 5.9C16.0025 5.78 16.0436 5.56 15.951 5.39L14.3053 2.62C14.2024 2.44 13.9864 2.38 13.8013 2.44L11.7544 3.24C11.3224 2.92 10.8698 2.66 10.3658 2.46L10.0572 0.34C10.0263 0.14 9.85147 0 9.64575 0H6.35425C6.14853 0 5.98395 0.14 5.9531 0.34L5.64452 2.46C5.1405 2.66 4.67764 2.93 4.25591 3.24L2.20901 2.44C2.02386 2.37 1.80786 2.44 1.705 2.62L0.0592423 5.39C-0.0436172 5.57 -0.00247327 5.78 0.162102 5.9L1.90043 7.22C1.85928 7.47 1.82843 7.74 1.82843 8C1.82843 8.26 1.849 8.53 1.89014 8.78L0.151816 10.1C-0.00247351 10.22 -0.0436172 10.44 0.0489564 10.61L1.69471 13.38C1.79757 13.56 2.01357 13.62 2.19872 13.56L4.24563 12.76C4.67764 13.08 5.13022 13.34 5.63423 13.54L5.94281 15.66C5.98395 15.86 6.14853 16 6.35425 16H9.64575C9.85147 16 10.0263 15.86 10.0469 15.66L10.3555 13.54C10.8595 13.34 11.3224 13.07 11.7441 12.76L13.791 13.56C13.9761 13.63 14.1921 13.56 14.295 13.38L15.9408 10.61C16.0436 10.43 16.0025 10.22 15.8379 10.1L14.1201 8.78ZM8 11C6.30282 11 4.91421 9.65 4.91421 8C4.91421 6.35 6.30282 5 8 5C9.69718 5 11.0858 6.35 11.0858 8C11.0858 9.65 9.69718 11 8 11Z"
      fill="#979797"
    />
  </svg>
)

const SettingIcon = (props) => <Icon component={SettingSvg} {...props} />

export { SettingIcon }
